export const ACTION = 'UPDATE_DICTIONARY';

export default payload => ({ type: ACTION, payload });



// WEBPACK FOOTER //
// ./src/apps/vocabularium/data/redux/actions/updateDictionary.js